import React, { useState, useEffect } from "react";
import "./select-days.scss";
import { DayOfWeek } from "../availability.types";

export interface SelectDaysProps {
  onDayClick?: (day: DayOfWeek, isSelected: boolean, allSelectedDays: Set<DayOfWeek>) => void;
  onAllDaysClick?: (allDaysSelected: boolean, selectedDays: Set<DayOfWeek>) => void;
  onSelectionChange?: (selectedDays: Set<DayOfWeek>) => void;
  discard: boolean;
  setDiscard: React.Dispatch<React.SetStateAction<boolean>>;
}

const dayMapping: Record<string, DayOfWeek> = {
  Sun: "sunday",
  Mon: "monday",
  Tue: "tuesday",
  Wed: "wednesday",
  Thur: "thursday",
  Fri: "friday",
  Sat: "saturday",
};

export const SelectDays: React.FC<SelectDaysProps> = ({
  onDayClick,
  onAllDaysClick,
  onSelectionChange,
  discard,
  setDiscard,
}) => {
  const [selectedDays, setSelectedDays] = useState<Set<DayOfWeek>>(new Set());
  // initial value of selected day is empty // this hosld the selected day

  const displayDays = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"]; // array of the days of the week
  const dayOfWeekValues = Object.values(dayMapping); //gathered all the values of the day mapping

  const handleDayClick = (displayDay: string): void => {
    const dayOfWeek = dayMapping[displayDay];
    const newSelectedDays = new Set(selectedDays); //creates a set for the selected day initialy it's empty
    const wasSelected = newSelectedDays.has(dayOfWeek);

    if (wasSelected) {
      newSelectedDays.delete(dayOfWeek);
    } else {
      newSelectedDays.add(dayOfWeek);
    }

    setSelectedDays(newSelectedDays);

    // Call parent callback with DayOfWeek values
    onDayClick?.(dayOfWeek, !wasSelected, newSelectedDays);
  };

  const handleAllDaysClick = (): void => {
    const newSelectedDays =
      selectedDays.size === dayOfWeekValues.length
        ? new Set<DayOfWeek>()
        : new Set(dayOfWeekValues);

    const allSelected = newSelectedDays.size === dayOfWeekValues.length;
    setSelectedDays(newSelectedDays);

    // Call parent callback with DayOfWeek values
    onAllDaysClick?.(allSelected, newSelectedDays);
  };

  // Call parent whenever selection changes
  useEffect(() => {
    onSelectionChange?.(selectedDays);
  }, [selectedDays]);

  const allDaysSelected: boolean = selectedDays.size === dayOfWeekValues.length;

  useEffect(() => {
    if (discard) {
      setSelectedDays(new Set());
      setDiscard(false);
    }
  }, [discard]);
  return (
    <div className="select-days-container">
      <div
        className={`days all-days ${allDaysSelected ? "selected" : ""}`}
        onClick={handleAllDaysClick}
      >
        <i className="fa-solid fa-list-check"></i>
      </div>
      {displayDays.map((displayDay) => {
        const dayOfWeek = dayMapping[displayDay];
        return (
          <div
            key={displayDay}
            className={`days ${selectedDays.has(dayOfWeek) ? "selected" : ""}`}
            onClick={() => handleDayClick(displayDay)}
          >
            {displayDay}
          </div>
        );
      })}
    </div>
  );
};

// import "./select-days.scss";

// export const SelectDays = () => {
//   return (
//     <div className="select-days-container">
//       <div className="days">
//         <i className="fa-solid fa-list-check"></i>
//         {/* <i className="fa-solid fa-check-double"></i> */}
//       </div>
//       <div className="days">Sun</div>
//       <div className="days">Mon</div>
//       <div className="days">Tue</div>
//       <div className="days">Wed</div>
//       <div className="days">Thur</div>
//       <div className="days">Fri</div>
//       <div className="days">Sat</div>
//     </div>
//   );
// };
